export const isIPhone = (ua = '') => !__IS_SERVER__ && ua.toLowerCase().includes('iphone');

export const isAndroid = (ua = '') => !__IS_SERVER__ && ua.toLowerCase().includes('android');

export const isHuawei = (ua = '') => !__IS_SERVER__ && ua.toLowerCase().includes('huawei');
